// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9wEN5","location":"Header_location__1rDdE"};